import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'

export type ScrollableProps = {
    children: ReactNode
    className?: string
}

export const Scrollable = ({ children, className }: ScrollableProps) => (
    <Box className={twMerge('h-full overflow-auto', className)}>{children}</Box>
)

Scrollable.displayName = 'Scrollable'
